import { cn } from "../lib/cn.ts";

/**
 * Indicador de carregamento.
 *
 * Sob `prefers-reduced-motion` a rotação para e o traço fica estático — o
 * elemento continua presente e anunciado, apenas sem movimento.
 */
export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <>
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        className={cn("size-4 animate-spin motion-reduce:animate-none", className)}
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          fill="none"
          stroke="currentColor"
          strokeOpacity="0.25"
          strokeWidth="2.5"
        />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
      {label !== undefined && <span className="sr-only">{label}</span>}
    </>
  );
}
